import * as THREE from 'three'
import { DEG2RAD } from 'three/src/math/MathUtils.js'

export class EditorAssetGrid {
  constructor(studio) {
    this.studio = studio

    // Create 32x32 grid using a single mesh
    const gridSize = 32
    const gridSpacing = 1
    const halfSize = (gridSize * gridSpacing) / 2

    const vertices = []

    // Inner 32x32 grid (skip outer edges at i=0 and i=32)
    // Lines parallel to X axis (running along Z direction)
    for (let i = 0; i <= gridSize; i++) {
      if (i === 0 || i === gridSize) continue // Skip outer edges
      const z = i * gridSpacing - halfSize
      vertices.push(-halfSize, 0, z)
      vertices.push(halfSize, 0, z)
    }

    // Lines parallel to Z axis (running along X direction)
    for (let i = 0; i <= gridSize; i++) {
      if (i === 0 || i === gridSize) continue // Skip outer edges
      const x = i * gridSpacing - halfSize
      vertices.push(x, 0, -halfSize)
      vertices.push(x, 0, halfSize)
    }

    // Outer 3x3 grid
    // Each outer square has the same dimensions as the entire 32x32 grid
    const outerSquareSize = gridSize * gridSpacing // Same as the full 32x32 grid
    const outerHalfSize = outerSquareSize * 1.5 // 3 squares total

    // Outer grid lines parallel to X axis
    for (let i = 0; i <= 3; i++) {
      const z = i * outerSquareSize - outerHalfSize
      vertices.push(-outerHalfSize, 0, z)
      vertices.push(outerHalfSize, 0, z)
    }

    // Outer grid lines parallel to Z axis
    for (let i = 0; i <= 3; i++) {
      const x = i * outerSquareSize - outerHalfSize
      vertices.push(x, 0, -outerHalfSize)
      vertices.push(x, 0, outerHalfSize)
    }

    const geometry = new THREE.BufferGeometry()
    geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3))

    const material = new THREE.LineBasicMaterial({ color: 'white', transparent: true, opacity: 0.2 })
    const mesh = new THREE.LineSegments(geometry, material)
    // mesh.scale.setScalar(1 / 32)
    mesh.position.y = -0.00001

    this.mesh = mesh

    this.north = new THREE.Mesh(
      new THREE.PlaneGeometry(12, 12), // 16px
      new THREE.MeshBasicMaterial({ transparent: true, opacity: 0.2 }) // grid opacity
    )
    this.north.material.map = this.studio.textureLoader.load('/north.png')
    this.north.material.map.colorSpace = THREE.SRGBColorSpace
    this.north.material.needsUpdate = true
    this.north.position.z = -26
    this.north.rotation.x = -90 * DEG2RAD
    this.mesh.add(this.north)
  }
}
